export default __webpack_public_path__ + "static/media/ic_eritrea.a8260640.svg";